
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The candidate's preferences in an ideal position.`}</p>
    <p>{`This is only available for uploaded candidate profiles and Apply with SEEK candidate profiles.
For candidate applications & purchased profiles this will be an empty list.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;